/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/Home/components/DataReliabilitySection.tsx.
 */

import React from "react";
import "./DataReliabilitySection.css";

const DataReliabilitySection: React.FC = () => {
  return (
    <section className="home-section">
      <h2 className="section-heading">Data Reliability assessment</h2>
      <p className="section-description">
        All submitted datasets undergo a screening process to ensure:
        <br />
        Methodological consistency
        <br />
        Adequate documentation
      </p>
      <p className="section-description">
        This process determines how the data is categorized within the database and how it is made available to users.
      </p>

      <h2 className="section-heading">Contributor responsibility</h2>
      <p className="section-description">
        By submitting data, contributors confirm that:
        <br />
        The data is accurate to the best of their knowledge
        <br />
        Appropriate permissions have been obtained
        <br />
        Sources and assumptions are clearly documented
      </p>
    </section>
  );
};

/** React component — Data Reliability Section. */
export default DataReliabilitySection;

